/*********************** Custom JS for Boost AI Search & Discovery  ************************/

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('FilterTreeVertical', {
      name: 'Add custom banner #225017',
      apply: () => ({
        afterRender: (element) => {
          try {
            const filterTreeElm = element.getRootElm();
            const bannerHTML = `<div class="boost-sd__see-your-size">
                                  <a class="boost-sd__see-your-size_url" href="https://www.whambamsystems.com/pages/mayfit">
                                  <img src="https://cdn.shopify.com/s/files/1/0016/6179/6450/t/26/assets/See%20your%20size.jpg?v=1711425058" 
                                  alt="See your size"
                                  width="100%"
                                  style="max-width:250px;"/>
                                  </a>
                              </div>`;
            if(!document.querySelector('.boost-sd__see-your-size')) {
              filterTreeElm.insertAdjacentHTML('afterend', bannerHTML);
            }
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });
  }
]);